export default __webpack_public_path__ + "static/media/logo-dark.d6973775.png";